<template>
  <div>
    <div class="title" @click="goBack">
      <van-icon name="arrow-left" />
      <h2>兑换</h2>
    </div>
    <div class="content">
      <div class="application-title">
        兑换申请
      </div>
      <van-form @submit="onSubmit" ref="vanForm" label-width="4em" label-align="right" :rules="rules">
        <van-field label="选择商品" class="name_field" v-model="form.goodsName" placeholder="请选择商品" :rules="rules.goodsName"
          @click="showPopup" readonly is-link />
        <van-field label="兑换数量" class="name_field" v-model="form.goodsAmount" placeholder="请输入您的兑换数量"
          @input="calculateGoodsSum" :rules="rules.goodsAmount" />
        <van-field label="消耗积分" disabled class="name_field" v-model="form.goodsSum" placeholder=""
          :rules="rules.goodsSum" />
        <van-field label="我的积分" disabled class="name_field" :value="form.myPoints" placeholder="" />
        <van-field label="收获地址 " class="name_field" v-model="form.address" placeholder="联系人+手机号+收获地址"
          :rules="rules.address" />
        <div class="btn_wrap">
          <van-button block type="info" :loading="loading" class="btn" native-type="submit">提交兑换</van-button>
        </div>
      </van-form>
      <div class="application-title">
        商品列表
      </div>
      <table class="application-table">
        <thead>
          <tr>
            <th>序号</th>
            <th>申请物品</th>
            <th>消耗积分</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in applications" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.goodsName }}</td>
            <td>{{ item.goodsSum }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <van-popup position="bottom" v-model="show">
      <van-picker show-toolbar title="选择商品" :columns="applications" @cancel="onCancel" @confirm="onConfirm"
        value-key="goodsName" />
    </van-popup>
  </div>
</template>

<script>
import { getExchangeList, exchangeGoods, getUserInfo } from '@/api/index'
import { Toast } from "vant";
export default {
  name: "tryOut",
  data() {
    return {
      applications: [
      ],
      form: {
        myPoints: 0,
        goodsAmount: '',
        goodsSum: '',
        goodsName: '',
        address: ''
      },
      loading: false,
      show: false,
      rules: {
        goodsName: [
          { required: true, message: '请选择你的兑换商品' },
        ],
        goodsAmount: [
          { required: true, message: '请输入您的兑换数量' },
        ],
        goodsSum: [
          { required: true, message: '请输入手机号', trigger: 'onBlur' },
        ],
        myPoints: [
          { required: true, message: '您的积分', trigger: 'onBlur' },
        ],
        address: [
          { required: true, message: '请输入联系人+手机号+收获地址' },
        ],
      },
    };
  },
  mounted() {
    this.getExchangeRecord();
    let user = JSON.parse(localStorage.getItem('user'));
    this.$set(this.form, 'myPoints', user.points);
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getGoodsSum() {
      if (this.form.goodsAmount && this.form.goodsSum) {
        const unitPrice = this.form.goodsSum / (this.form.goodsAmount || 1);
        this.form.goodsSum = this.form.goodsAmount * unitPrice;
      }
    },
    calculateGoodsSum() {
      if (this.form.goodsName && this.form.goodsAmount) {
        const selectedItem = this.applications.find(item => item.goodsName === this.form.goodsName);
        if (selectedItem) {
          const unitPrice = selectedItem.goodsSum;
          this.form.goodsSum = this.form.goodsAmount * unitPrice;
        }
      }
    },
    getInfo() {
      getUserInfo().then((res) => {
        console.log(res);
        this.user = res;
        this.$set(this.form, 'myPoints', res.points);
        console.log(this.form.myPoints);

        localStorage.setItem('user', JSON.stringify(res));
      })
    },
    showPopup() {
      this.show = true;
    },
    onCancel() {
      this.show = false;
    },
    onConfirm(item) {
      this.form.goodsName = item.goodsName;
      // 保存单个商品的积分价值
      this.form.unitPrice = item.goodsSum;
      // 如果已经输入了数量，则计算总积分
      if (this.form.goodsAmount) {
        this.form.goodsSum = this.form.goodsAmount * item.goodsSum;
      } else {
        this.form.goodsSum = item.goodsSum;
      }
      this.show = false;
    },
    handleAction(item) {
      // 撤销申请的逻辑
      console.log("撤销申请:", item);
      // 这里可以添加 API 调用来撤销申请
    },
    onSubmit() {
      // 校验表单
      this.$refs.vanForm.validate().then(() => {
        console.log("提交表单:", this.form);
        let form = { ...this.form };
        this.loading = true;
        let data = {
          id: this.applications.find(item => item.goodsName == form.goodsName).id,
          phone: form.address.split('+')[1],
          address: form.address.split('+')[2],
          goodsName: form.goodsName,
          goodsSum: form.goodsSum,
          goodsAmount: form.goodsAmount,
        }
        console.log(data);

        exchangeGoods(data).then((res) => {
          this.form = {
            myPoints: this.form.myPoints,
            goodsAmount: '',
            goodsSum: '',
            goodsName: '',
            address: ''
          };
          this.loading = false;
          this.getInfo()
          Toast.success('兑换成功');
        }).catch((err) => {
          console.log(err);
          this.loading = false;
        });

      }).catch((error) => { });
    },
    //获取兑换记录
    async getExchangeRecord() {
      let data = {
        page: 1,
        size: 999
      }
      const res = await getExchangeList(data);
      console.log(res);

      this.applications = res;
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${month}-${day}`;
    },
  },
};
</script>

<style scoped>
.title {
  padding: 20px 20px 10px;
  font-size: 20px;
  font-weight: bold;
  border-bottom: 1px solid #ccc;
  display: flex;
  align-items: center;
}

.content {
  padding: 20px 20px 50px;

}

.application-table {
  width: 100%;
  border-collapse: collapse;
}

.application-table th,
.application-table td {
  border: 1px solid #e0e0e0;
  padding: 10px;
  text-align: left;
}

.application-table th {
  background-color: #f9f9f9;
}

.application-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.btn {
  background-color: rgba(43, 70, 138, 1);
  color: #fff;
  font-size: 0.14rem;
  text-align: center;
  font-family: Roboto;
  border-radius: 8px;
  margin: 20px 0;
}
</style>
